export function formatCurrency(amount: string | number): string {
  const numericAmount = Number(amount);
  if (isNaN(numericAmount)) return "₦0";

  return `₦${numericAmount.toLocaleString("en-NG", {
    maximumFractionDigits: 0,
  })}`;
}
